import React, {useState} from "react";
import {Button} from "../../../components/My/Button";
import {apiGetEventList, apiGetEntrances} from "./Actions";
import Datatable from "../../../components/datatable";
import moment from "moment";
import {Form} from "react-final-form";
import Modal from "../../../components/My/Modal";
import CheckboxField from "../../../FinalForm/CheckboxField";


const GetEventsList = ({subject}) => {

    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let [modalEntrances, setModalEntrances] = useState(false);
    let [eventId, setEventId] = useState(null);
    let submit;

    const getTariffList = () => {
        setLoading(true);
        apiGetEventList(subject.id, (response) => {
            setData(response)
            setLoading(false);
        }, (error) => {
            setLoading(false);
        })
    }

    const getEntrances = (values) => {
        setLoading(true);
        apiGetEntrances(eventId, values.getFromSystem, values.sendToEnigoo,
            values.sendToSlack, (response) => {
                setModalEntrances(false)
                setLoading(false);
            }, (error) => {
                setLoading(false);
            })
    }

    let columns = [
            {Header: 'ID', accessor: "id"},
            {
                Header: 'Událost', accessor: d => (
                    <>
                        <div>{d?.name}</div>
                        <div>{moment(d?.startTime).format('D. M. YYYY HH:mm')}</div>
                    </>
                )
            },
            {Header: 'Průchodů', accessor: "ticketEntrance"},
            {
                Header: 'Odstranění', accessor: d => (
                    <Button text={"Návštěvnost"} color={"bg-blue-500"} onClick={() => {
                        setModalEntrances(true)
                        setEventId(d.id)
                    }}/>
                )
            }
        ]
    ;


    return (
        <>
            <Button onClick={getTariffList} text={"Načti události"} loading={loading}/>
            {data && <Datatable data={data} columns={columns}/>}

            <Modal title={"Načteční návštěvnosti"}
                   body={<Form
                       onSubmit={getEntrances}
                       render={({handleSubmit, errors}) => {
                           submit = handleSubmit
                           return (
                               <>
                                   <CheckboxField name={"getFromSystem"} label={"Stáhnout ze systému třetí strany"}/>
                                   <CheckboxField name={"sendToEnigoo"} label={"Odeslat vše do ENIGOO"}/>
                                   <CheckboxField name={"sendToSlack"} label={"Odeslat výsledek do slacku"}/>
                               </>
                           )
                       }}/>}
                   visible={modalEntrances}
                   close={() => {
                       setModalEntrances(false)
                       setEventId(null)
                   }}
                   footer={<>
                       <Button text={"Uložit"} onClick={() => submit()} loading={loading}/>
                       <Button text={"Zrušit"} onClick={() => {
                           setModalEntrances(false)
                           setEventId(null)
                       }}/>
                   </>
                   }
            />

        </>
    )
}

export default GetEventsList
